module.exports = __webpack_public_path__ + "static/media/S11_B.b171b3d5.png";